import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginModel } from '../models/login.model';
import { OtpModel } from '../models/otp.model';
import { AuthResponse } from '../models/auth-response.model';
import { LoginService } from './login.service';
import { TwoFactorSetupResponse, Verify2FARequest } from '../models/twofa.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private api: LoginService) {}

  login(data: LoginModel): Observable<AuthResponse> {
    return this.api.post<AuthResponse>('auth', 'login', data);
  }

  // verifyOtp(data: OtpModel): Observable<AuthResponse> {
  //   return this.api.post<AuthResponse>('auth', 'verify-otp', data);
  // }

  setup2FA() {
    return this.api.post<TwoFactorSetupResponse>('auth', '2fa/setup', {});  
  }

  verify2FA(data: Verify2FARequest) {
    return this.api.post<any>('auth', '2fa/verify', data);
  }

  verifyLogin2FA(code:string){
    return this.api.post<any>(
      'auth', '2fa/login-verify', { code }
    )
  }

  GetUserPermissions(): Observable<any>{
    return this.api.get<any>('auth', 'permissions');
  }

  logout() {
    localStorage.removeItem("token");
  }

  saveToken(token: string) {
    localStorage.setItem("token", token);
  }

  getToken(): string | null {
    // return localStorage.getItem("token");
    const token =
          localStorage.getItem("token")
          || localStorage.getItem("tempToken");
    return token;
  }

}